export const LOGIN = "/login";
export const DASHBOARD = "/";
export const PROFILE = "/profile";

//
export const ORDER = "/orders";
export const ORDER_VIEW = "/orders/view/:id";

//
export const PRODUCTS = "/products";
export const PRODUCT_CREATE = "/products/create";
export const PRODUCT_EDIT = "/products/edit/:id";
export const PRODUCT_VIEW = "/products/view/:id";

//
export const CATEGORIES = "/categories";
export const CATEGORY_CREATE = "/categories/create";

//
export const OFFERS = "/offers";
//
export const COUPONS = '/coupons';
//
export const ADVERTISEMENTS = "/advertisements";
//
export const LANDING_IMAGES = '/landing-images';


//
export const USERS = "/users";

//
export const REVIEWS = "/reviews";

//

//
export const INQUIRIES = "/inquiries";

//
export const ROLES = "/roles";

//
export const SUBSCRIPTIONS = "/subscriptions";

//
export const CUSTOMERS = "/customers";
//
export const DEFAULTSETTINGS = "/defaultsettings";
//
export const DRIVER_ORDER_DELIVERY = '/driver/order-delivery';
